import React from 'react'
import { useTranslation } from 'react-i18next';
import background from '../../../images/background.png'
import icon1 from '../assets/Group-1.png'
import icon2 from '../assets/Group-2.png'
import icon3 from '../assets/Group.png'
import { Link } from 'react-router-dom'
import { motion } from "framer-motion";


function Weather({ scrollRef }) {
  const { t } = useTranslation();
  
  return (
    <div className="w-screen lg:h-fit lg:min-h-screen -z-50 relative my-9 lg:my-0">
      <div className="lg:block absolute left-0 top-0 z-0 scale-y-[-1] hidden ">
        <img src={background} className=" w-[20vw] h-[50%]" alt={t("weather.title")} />
      </div>
      <div className="lg:block absolute right-0 bottom-0 z-0 scale-x-[-1] hidden ">
        <img src={background} className=" w-[20vw] h-[50%]" alt={t("weather.title")} />
      </div>
      <div className=" lg:w-[47%] flex text-center mx-auto items-center lg:py-9 h-full  ">
        <div className=" flex flex-col lg:gap-16 ">
          <motion.div
            ref={scrollRef}
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ root: scrollRef, once: true }}
            className="text-3xl font-bold flex flex-col gap-3 mb-4"
          >
            <div className="">{t("weather.title")}</div>
            <span className="text-primary">{t("weather.subtitle")}</span>
          </motion.div>
          <div className="flex flex-col-reverse lg:flex-row items-center gap-10 justify-between py-10 lg:py-0">
            <motion.img
              ref={scrollRef}
              initial={{ opacity: 0, x: 75 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ root: scrollRef, once: true }}
              src={icon1}
              alt={t("weather.icons.weather1")}
              className="lg:w-[10rem] lg:h-[9rem] w-[8rem] h-[7rem] "
            />
            <img
              src={icon3}
              alt={t("weather.icons.weather2")}
              className="lg:w-[10rem] lg:h-[9rem] w-[8rem] h-[7rem] "
            />
            <motion.img
              ref={scrollRef}
              initial={{ opacity: 0, x: -75 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ root: scrollRef, once: true }}
              src={icon2}
              alt={t("weather.icons.weather3")}
              className="lg:w-[10rem] lg:h-[9rem] w-[8rem] h-[7rem] "
            />
          </div>
          <motion.div
              ref={scrollRef}
              initial={{ opacity: 0, y: 75 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ root: scrollRef, once: true }} 
              className="flex flex-col gap-7 items-center">
            <p className="lg:text-2xl text-lg font-bold lg:font-medium px-8">
              {t("weather.description")}
            </p>
            <Link to="/home/weather">
              <div className="w-[11rem] bg-primary text-center text-white font-bold p-3 rounded-[17.5px]">
                {t("common.knowMore")}
              </div>
            </Link>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Weather;